import { NetworkRequestOptions } from '../../../core/interfaces/request';
import { AppConfig } from '../../../core/app.config';
import { courier } from '../../../core/services/courier.service';
import { createHttpParams } from '../../../core/utils/request';

const appConfig = new AppConfig();

export const DestinationTypesAPI = {
  mapperUrl: appConfig.getMapperURL(),

  getDataTypes(destType: string, showLoading = true): Promise<any> {
    const requestUrl = `${this.mapperUrl}/data-types`;

    const options: NetworkRequestOptions = {
      networkOptions: {
        params: createHttpParams({
          destination_type: destType
        })
      },
      uiOptions: {
        showLoading
      }
    };

    return courier.get(requestUrl, options);
  }
};
